import { createFileRoute } from '@tanstack/react-router';

import { PatientsPage } from '@/features/emr/pages/PatientsPage';

export const Route = createFileRoute('/_authenticated/patients/')({
  component: PatientsPage,
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/patients', title: 'Patients' }],
  }),
});
